import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { ColumnSelectionComponent } from './column-selection.component';

@NgModule({
  declarations: [ColumnSelectionComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    TranslateModule,
    MatRippleModule,
    MatCheckboxModule,
    DragDropModule,
    MatIconModule,
  ],
  exports: [ColumnSelectionComponent],
  providers: [],
})
export class ColumnSelectionModule {}
